var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "sub-header" }, [
    _c("img", {
      staticClass: "mobile-logo",
      attrs: {
        src: "static/img/leakcentral_horizontal.svg",
        alt: "mobile-logo",
      },
    }),
    _vm._v(" "),
    _c("span", { staticClass: "mobile-minimizer" }, [
      _c(
        "button",
        {
          staticClass:
            "navbar-toggler mobile-sidebar-toggler d-lg-none mobile-header",
          attrs: { type: "button" },
          on: { click: _vm.mobileSidebarToggle },
        },
        [_c("span", { staticClass: "navbar-toggler-icon" })]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }